import React from 'react';
import styles from './slider.module.sass';
import { useEmblaSlider } from '../../hooks/useEmblaSlider';
import { Image } from '../Image/Image';

/**
 * Каруселька.
 * Всегда нужно оборачивать в Провайдер
 */
export const Carousel = ({ data = [] }) => {
  const { ref, current } = useEmblaSlider();
  return (
    <div className={styles.embla} ref={ref}>
      <div className={styles.emblaContainer}>
        {data.map(({ url, description }) => (
          <div key={description} className={styles.emblaSlide}>
            <Image
              src={url.src}
              srcSet={url.srcset}
              alt={description}
              loading={'lazy'}
            />
          </div>
        ))}
      </div>
      <div className={styles.current}>
        {current + 1} из {data.length}
      </div>
    </div>
  );
};
